export default __webpack_public_path__ + "772becf.png";